import {isSameDay} from 'date-fns';

import {SLOT_HEIGHT_IN_PIXELS} from '../constants/slotHeight';
import {calculateTimePosition} from './calculateTimePosition';

/**
 * Calculates the duration in pixels between start and end time
 * @param start Start date
 * @param end End date
 * @returns Duration in pixels
 */
export function calculateDuration(start: Date, end: Date): number {
  const startPosition = calculateTimePosition(start);
  let endPosition = calculateTimePosition(end);

  // If end is on a different day than start, we need to handle this specially
  if (!isSameDay(start, end)) {
    // If end is the next day at 0:00, treat it as 24:00 of the start day
    if (end.getHours() === 0 && end.getMinutes() === 0) {
      // Calculate 24:00 as 24 hours * SLOT_HEIGHT_IN_PIXELS
      endPosition = 24 * SLOT_HEIGHT_IN_PIXELS;
    }
  }

  return endPosition - startPosition;
}
